import React from 'react'
import { navigationConfig } from '../../config/navigationItems'

import NavItem from '../NavItem'
import { useTheme } from '@material-ui/core/styles'
import { useVendorPlan } from '../../../hooks'
import { PlanStatus } from '../../../models'

export const VendorItems = () => {
    const theme = useTheme()
    const { plan, loading } = useVendorPlan()

    const showItem = (item: typeof navigationConfig.vendor.mainItems[0]) => {
        if (!item.requiredPremium) return true
        if (loading) return false
        return plan === PlanStatus.PREMIUM
    }

    const mainItems = navigationConfig.vendor.mainItems.filter(showItem)
    const footerItems = navigationConfig.vendor.footerItems

    return (
        <>
            {mainItems.map((item) => (
                <NavItem key={item.name} item={item} />
            ))}
            <div
                style={{
                    marginTop: 10,
                    marginBottom: 10,
                    borderTop: `2px solid ${theme.palette.grey[800]}`,
                }}
            />
            {footerItems.map((item) => (
                <NavItem key={item.name} item={item} />
            ))}
        </>
    )
}
